module.exports = __webpack_public_path__ + "static/media/hengshan_web.51fac4c8.png";